// extracted by mini-css-extract-plugin
var _1 = "ActivityTabContent__calendar--GvyLg";
var _2 = "ActivityTabContent__calendarOffice--zvyDJ ActivityTabContent__calendar--GvyLg";
var _3 = "ActivityTabContent__dayHeader--SNVSv fontSize__profileHead--IaEKt";
var _4 = "ActivityTabContent__dayHeaderOffice--brlK_";
var _5 = "ActivityTabContent__dayHeaderSchool--e3WKA";
var _6 = "ActivityTabContent__dayPanel--ETtj9 fontSize__profileText--q79uE";
var _7 = "ActivityTabContent__dayPanelOffice--p4luh CoreGeneral__textSizeB--joAuE";
var _8 = "ActivityTabContent__dayPanelSchool--IDeH1 CoreGeneral__textSizeB--joAuE";
var _9 = "ActivityTabContent__detailTable--rW1VD";
var _a = "ActivityTabContent__info--VLFFI";
export { _1 as "calendar", _2 as "calendarOffice", _3 as "dayHeader", _4 as "dayHeaderOffice", _5 as "dayHeaderSchool", _6 as "dayPanel", _7 as "dayPanelOffice", _8 as "dayPanelSchool", _9 as "detailTable", _a as "info" }
